<template>
  <div v-if="curInfoNum > 0" style="margin-top:20px;">
    <div v-for="(item,index) in curErrorInfo" :key="index">
      <!-- color="#ffc2c2" @input="close(item, index)" -->
      <v-alert
        v-if="item.seq_index < 4 || showMoreProp"
        border="left"
        colored-border
        color="#fe6c6f"
        type="error"
        dismissible
        style="margin: 10px;min-width: 280px;background-color: #ffeaea;"
      >
        <p style="margin: 0;color: #F56C6C;display: block;">
          {{ item.msg }}<span v-if="item.time_begin" style="margin-left: 20px;">( {{formBeginTime(item.time_begin)}} )</span>
        </p>
        <template v-slot:close="{toggle}">
          <v-icon
            dark
            right
            color="red"
            @click="closeAlert(toggle, item, index)"
          >
            mdi-close-circle
          </v-icon>
        </template>
      </v-alert>
    </div>
    <div v-if="curInfoNum > 4" style="color:#9e9e9e;font-size:0.8rem;text-align:center;margin-top:0.5rem;">
      <span @click="showMoreProp=!showMoreProp">
        <span v-if="!showMoreProp">
          查看更多
          <i class="fa fa-angle-down" style="margin-left:0.3rem;color:#9e9e9e;font-size:0.9rem;" aria-hidden="true" />
        </span>
        <span v-else>
          收起
          <i class="fa fa-angle-up" style="margin-left:0.3rem;color:#9e9e9e;font-size:0.9rem;" aria-hidden="true" />
        </span>
      </span>
    </div>
    <div style="box-shadow: rgba(0, 0, 0, 0.2) 0px -4px 4px -1px; height:12px;margin-top:20px;">
      &nbsp;
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceErrorMessage',
  components: {},
  props: {
    iotId: {
      type: String,
      default: ''
    },
    errorInfo: {
      type: Array,
      default: () => {
        return []
      }
    },
    serverTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      totalInfo: 0,
      curInfoNum: 0,
      showMoreProp: false,
      curErrorInfo: []
    }
  },
  watch: {
    errorInfo() {
      this.assign()
    }
  },
  computed: {},
  mounted() {
    this.assign()
  },
  activated() {},
  deactivated() {},
  methods: {
    async close(item, index) {
      var that = this
      console.log('item', item)
      that.submitServiceCmd(item.id)
      that.curInfoNum--;
      that.curErrorInfo[index].seq_index = -1
      for (let i = index; i < that.curErrorInfo.length; i++) {
        const item = that.curErrorInfo[i]
        if (item.seq_index === -1) {
          continue
        }
        item.seq_index--
      }
    },
    async closeAlert(toggle, item, index) {
      // console.log('item', item)
      var that = this
      const flag = await that.submitServiceCmd(item.id)
      if (flag) {
        toggle()
        that.refresh(index)
      }
    },
    refresh(index) {
      var that = this
      that.curInfoNum--;
      that.curErrorInfo[index].seq_index = -1
      for (let i = index; i < that.curErrorInfo.length; i++) {
        const item = that.curErrorInfo[i]
        if (item.seq_index === -1) {
          continue
        }
        item.seq_index--
      }
    },
    formBeginTime(d) {
      var that = this
      if (d) {
        var ecount = that.$moment().diff(that.$moment(d), 'days')
        if (ecount <= 7) {
          if (that.serverTime) {
            return that.$moment(d).from(that.serverTime)
          }
          return that.$moment(d).from()
        } else {
          return that.$moment(d).format('YYYY-MM-DD HH:mm')
        }
      }
      return ''
    },
    assign() {
      var that = this
      that.totalInfo = that.errorInfo.length
      that.curInfoNum = that.errorInfo.length
      var arr = []
      for (let i = 0; i < that.errorInfo.length; i++) {
        const item = that.errorInfo[i]
        item['seq_index'] = i
        arr.push(item)
      }
      this.curErrorInfo = arr
    },
    // 提交服务
    async submitServiceCmd(id) {
      var that = this
      var res = await that.$api.iot.submitServiceCmd({ iot_id: that.iotId, method: 'clear_alarm', item: `{ "id": ${id},  }` })
      // console.log('submitServiceCmd.res', res)
      if (!res.success) {
        that.$toast.warning(res.error_msg ? res.error_msg : '关闭警告失败')
        console.log('关闭警告失败', res)
        return false
      }
      // if (res.code && (res.code === '200' || res.code === 200)) {
      //   that.$toast.success(res.msg ? res.msg : '关闭警告成功')
      //   return true
      // } else {
      //   that.$toast.warning(res.msg ? res.msg : '关闭警告失败')
      //   return false
      // }
      that.$toast.success('关闭警告成功')
      return true
    }
  }
}
</script>

<style scoped>
.us_state_card{
  height: 7rem;
  line-height: 7rem;
  margin-bottom: 0.3rem;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}
</style>
